import type { FC } from "react";
import { DashboardTimelinePreview } from "web_myplann/Dashboard/Components/DashboardTimelinePreview";
import { useDashboardRecentPreview } from "web_myplann/Dashboard/Hooks/useDashboardRecentPreview";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { TimelineEntry } from "web_myplann/NotificationCenter/Components/TimelineEntry";
import { NOTIFICATION_CENTER_TABS } from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";
import { useNavigateFromTimelineItem } from "web_myplann/NotificationCenter/Hooks/useNavigateFromTimelineItem";
import { DASHBOARD_ORIGIN } from "web_myplann/NotificationCenter/Utils/notificationOrigin";

interface DashboardRecentSectionProps {
	onEmptyChange?: (isEmpty: boolean) => void;
}

export const DashboardRecentSection: FC<DashboardRecentSectionProps> = ({
	onEmptyChange,
}) => {
	const { t } = useResource();
	const preview = useDashboardRecentPreview();
	const navigateToItem = useNavigateFromTimelineItem({
		origin: DASHBOARD_ORIGIN,
	});

	return (
		<DashboardTimelinePreview
			title={t(Resources.Dashboard.NotificationSections.Recent)}
			items={preview.items}
			hasMore={preview.hasMore}
			isLoading={preview.isLoading}
			showAllTab={NOTIFICATION_CENTER_TABS.Recent}
			ItemComponent={TimelineEntry}
			testId="dashboard-recent"
			onItemClick={navigateToItem}
			onEmptyChange={onEmptyChange}
		/>
	);
};
